import ServerError from './ServerError'

export default class AuthorizationError extends ServerError {}